export const FAKE_PROGRESS_MIN_TIME_MS = 2000;
export const USED_FILES_PAGE_SIZE = 20;
export const DAYS_IN_USE_TO_CHECK = 30;
//# sourceMappingURL=modalConstants.js.map